const getAPIError = e => {
  const { payload: { errors = [] } = {} } = e;
  const error = errors[0] || {};
  return error.message || e.message || "Unknown error";
};

export default getAPIError;
